module.exports = __webpack_public_path__ + "img/ic-chev-s-denim.0ea61a19.svg";